<div class="si-input {{styleClass}}"
     [class.si-input_number]="type === 'number'"
     [class.disabled]="disabled"
     [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted || validationExternalErrorText)"
     [class.validation-warning]="validationExternalWarningText">
  <ng-container *ngIf="!hideLabel">
    <si-label [text]="text"
              [tooltipText]="tooltipText"
              [tooltipPosition]="tooltipPosition"
              [tooltipIcon]="tooltipIcon"
              [tooltipStyleClass]="tooltipStyleClass"
              [tooltipEscape]="tooltipEscape"
              [forceShowTooltipIcon]="forceShowTooltipIcon"
              (tooltipIconClick)="onClickTooltipIcon($event)"
              forId="si-input-{{id}}"
    ></si-label>
  </ng-container>
  <div class="si-input_input" siProvideParentForm>
    <input #formModel="ngModel"
           id="si-input-{{id}}"
           name="{{name}}"
           type="{{type}}"
           autocomplete="off"
           placeholder="{{disabled ? '' : (placeholder | translate)}}"
           [disabled]="disabled"
           [siAutoFocus]="autoFocus"
           [ngModel]="model"
           [ngModelOptions]="{updateOn: updateNgModelOnBlur ? 'blur' : 'change'}"
           (ngModelChange)="onChangeModel($event)"
           siValidation="{{rule}}"
           [siValidationElement]="validationElement"
           [siValidationExternalErrorText]="validationExternalErrorText"
           [siValidationExternalWarningText]="validationExternalWarningText">
    <i *ngIf="showPasswordIconEnabled"
       [ngClass]="showPassword ? 'icon-eyeblocked' : 'icon-eye'"
       class="si-input_input_display-password"
       (click)="onClickShowPassword($event)"
    ></i>
    <si-validation-element #validationElement
                           [formModel]="formModel"
                           [showErrorText]="!showRuleErrorOutsideIcon"
                           (errorTextChange)="validationErrorText = $event"
                           class="si-input_input_validation"
    ></si-validation-element>
    <div *ngIf="type === 'number'" class="si-input_input-arrows-container">
      <div class="si-input_input-arrows">
        <div (click)="onClickArrow(true)" [class.disabled]="(max || max == 0) && model == max">
          <i class="icon-up"></i>
        </div>
        <div (click)="onClickArrow(false)" [class.disabled]="(min || min == 0) && model == min">
          <i class="icon-down"></i>
        </div>
      </div>
    </div>
    <i *ngIf="inputIcon" class="{{inputIcon}} si-input_input_icon"></i>
  </div>
  <div *ngIf="showRuleErrorOutsideIcon">
    <si-validation-error-text [text]="validationErrorText || validationExternalErrorText"
                              [textWarning]="validationExternalWarningText"
                              [formModel]="formModel"
    ></si-validation-error-text>
  </div>
  <div *ngIf="capsLock" class="si-input_caps-lock" translate="CORE_CAPS_LOCK_ACTIVATED"></div>
</div>
